import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls window to top on every route change.
 * Skips when the URL has a hash (e.g. /#contact) so in-page anchors still work,
 * and skips when a query parameter is present (e.g. /projects/film-tv?project=3)
 * so deep links to a specific project don't snap back to the top.
 */
const ScrollToTop = () => {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    if (hash || search) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash, search]);

  return null;
};

export default ScrollToTop;
